import React from 'react'
import { createRoot } from 'react-dom/client'
import '../polyfills'

import AuthContainer from './containers/auth-container'

const container = document.getElementById('main')
const root = createRoot(container)
root.render(<AuthContainer />)
